import api from './api';

export const agencyService = {
  async getAgencies(params = {}) {
    const response = await api.get('/agencies', { params });
    return response.data;
  },
  
  async getAgencyById(id) {
    const response = await api.get(`/agencies/${id}`);
    return response.data;
  },
  
  async createAgency(agencyData) {
    const response = await api.post('/agencies', agencyData);
    return response.data;
  },
  
  async updateAgency(id, agencyData) {
    const response = await api.put(`/agencies/${id}`, agencyData);
    return response.data;
  },
  
  async deleteAgency(id) {
    const response = await api.delete(`/agencies/${id}`);
    return response.data;
  },
  
  async toggleAgencyStatus(id, isActive) {
    const response = await api.patch(`/agencies/${id}/status`, { isActive });
    return response.data;
  },
  
  async getAgencyReservations(id, params = {}) {
    const response = await api.get(`/agencies/${id}/reservations`, { params });
    return response.data;
  },
  
  async getAgencyAccount(id, currency) {
    const response = await api.get(`/agencies/${id}/account`, { params: { currency } });
    return response.data;
  },
  
  async getAgencyPrices(id, params = {}) {
    const response = await api.get(`/agencies/${id}/prices`, { params });
    return response.data;
  },
  
  async createAgencyPrice(id, priceData) {
    const response = await api.post(`/agencies/${id}/prices`, priceData);
    return response.data;
  },
  
  async updateAgencyPrice(agencyId, priceId, priceData) {
    const response = await api.put(`/agencies/${agencyId}/prices/${priceId}`, priceData);
    return response.data;
  },
  
  async deleteAgencyPrice(agencyId, priceId) {
    const response = await api.delete(`/agencies/${agencyId}/prices/${priceId}`);
    return response.data;
  }
};
